import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancel = () => (
  <div className="min-h-screen bg-[#030303] flex items-center justify-center px-4 text-center" data-testid="payment-cancel">
    <div>
      <XCircle size={56} className="text-white/40 mx-auto" />
      <h1 className="font-heading font-bold text-2xl text-white mt-6">Checkout canceled</h1>
      <p className="mt-3 text-white/60">No charge was made. You can subscribe anytime.</p>
      <Link to="/premium" className="inline-block mt-8 rounded-full bg-[#00F0FF] text-black font-semibold px-8 py-3 hover:scale-105 transition-transform">Back to Premium</Link>
    </div>
  </div>
);

export default PaymentCancel;
